require("./save-search.scss");

import SaveSearchRenderer from "./renderer";

(function ($, data) {

    $(function () {

        const domNode = document.body.appendChild(document.createElement("div"));

        $("[data-toggle='save-search']").click(function () {
            new SaveSearchRenderer(domNode, data).render();
        });


        $(document.body).on("save-search:saved", function () {
            const fbq = window._fbq || function () { };

            fbq("trackcustom", "save search", {
                content_type: "vehicle",
                currency: "AUD",
                value: 0
            });
        });

    });

})(jQuery, window.saved_search_data);